import { AUTH_COOKIE_EXPIRY_DURATION_MS } from "./constants";

export const getAuthCookieExpireDate = () => {
  return new Date(Date.now() + AUTH_COOKIE_EXPIRY_DURATION_MS);
};
